<script setup lang="ts">
import { formatDate } from '@/services/utils'
import { computed } from 'vue'

const isNearExpiration = computed(() => {
	const diff = new Date(sessionMap.licenseExpiration).getTime() - new Date().getTime()
	const days = diff / 86400000
	return days <= 31
})
const licenseExpiration = computed(() => formatDate(sessionMap.licenseExpiration))

const show = computed(() => isNearExpiration)
</script>

<template v-if="show">
	<div v-if="isNearExpiration" class="row">
		<div class="col">
			<div class="alert alert-warning" role="alert">
				{{ $t('licenseExpires') }} <b>{{ licenseExpiration }}</b>
			</div>
		</div>
	</div>
</template>
